module.exports = __webpack_public_path__ + "img/logo.6915e1c5.svg";